import * as Sentry from '@sentry/react'

declare const PACKAGE_NAME: string
declare const PACKAGE_VERSION: string
declare const COMMIT_HASH: string

export const setupSentry = (): void => {
  Sentry.init({
    dsn: 'https://d16d3d25ac134d689de5f495aa03c372@o793342.ingest.sentry.io/5801370',
    integrations: [Sentry.browserTracingIntegration()],
    environment:
      window.location.hostname === 'registration.kingenergy.com'
        ? 'production'
        : 'development',
    release: `${PACKAGE_NAME}@${PACKAGE_VERSION}:${COMMIT_HASH}`,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}
